import { PaletteOptions } from '@mui/material/styles';

import { ColorOverrides } from './types';

export const shadows = {
  buttonSdw: '0px 4px 10px 0px #00000008',
  popperShw: '0px 4px 24px 0px #0000001A',
};

export const colors: {
  light: PaletteOptions & ColorOverrides;
  dark: PaletteOptions & ColorOverrides;
} = {
  light: {
    primary: {
      main: '#39CA88',
    },
    text: {
      primary: 'currentcolor',
      secondary: '#9299A6',
      disabled: '#666666',
    },
    background: {
      default: '#FFFFFF',
      paper: '#F7F7F8',
      contrast: '#0A0E20',
      input: '#FCFCFC',
      select: '#22273C',
      primary: 'rgba(57, 202, 136, 0.10)',
      icon: '#F7F7F81A',
      active: '#151E45',
    },
    grey: {
      50: '#F8F8F8',
      100: '#F1F1F4',
      200: '#f5f5f5',
      300: '#e6e6e6',
      400: '#657795',
    },
    warning: {
      main: '#CC7700',
      light: '#FFD59933',
      dark: '#FFBC9D33',
    },
    error: {
      main: '#E6483D',
      light: '#FFBC9D33',
      dark: '#CC4608',
    },
    success: {
      main: '#0FB168',
      light: '#9EEBC433',
      dark: '#077C40',
    },
    borders: {
      main: '#E4E4E4',
      light: '#F1F2F4',
    },
    common: {
      white: '#FFFFFF',
      black: '#000000',
    },
    info: {
      main: '#7297F6',
      dark: '#7297F6',
      light: '#626B91',
    },
  },
  dark: {
    primary: {
      main: '#39CA88',
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#9299A6',
      disabled: '#A4A4A4',
    },
    background: {
      default: '#161A2B',
      paper: '#2E3552',
      contrast: '#0A0E20',
      input: '#272D47',
      select: '#22273C',
      primary: 'rgba(57, 202, 136, 0.10)',
      icon: '#F7F7F81A',
      active: '#151E45',
    },
    grey: {
      50: '#2C2C2C',
      100: '#373737',
      200: '#424242',
      300: '#616161',
      400: '#BDBDBD',
    },
    warning: {
      main: '#FFBC5D',
      light: '#FFD59933',
      dark: '#F5841F',
    },
    error: {
      main: '#E6483D',
      light: '#FFBC9D33',
      dark: '#FF9564',
      contrastText: '#FF4E00',
    },
    success: {
      main: '#0CB860',
      light: '#73FFB7',
      dark: '#9EEBC433',
    },
    borders: {
      main: '#464F74',
      light: '#1C1C1C',
    },
    common: {
      white: '#FFFFFF',
      black: '#000000',
    },
    info: { main: '#7297F6', dark: '#7297F6', light: '#626B91' },
  },
} as const;

export const chartColors = {
  green: '#39CA88',
  blue: '#2276FC',
  skyBlue: '#399ECA',
  ultramarineBlue: '#3E6EEA',
  hotPink: '#EE6AF9',
  greenLight: '#25CD25',
  greenDark: '#1B8263',
  blueViolet: '#4D63C1',
  limeGreen: '#A8CF56',
  goldenYellow: '#E1CB57',
  royalBlue: '#5B58F0',
  coralOrange: '#F08F58',
  burntOrange: '#F07358',
  turquoise: '#58F0C2',
  lavender: '#AB84DE',
  lightBlue: '#84B8DE',
  grey: '#9C9DAF',
  brightPurple: '#D022FC',
  silver: '#CACACA',
  gold: '#DCB52B',
};

export const svgColors = {
  orange: '#F5841F',
  purple: '#CA1FF5',
};
